<main class="container-fluid">
  <div class="center">
    <div class="grid">
      @if (!tokenError) {
        <div class="col" style="max-width: 40rem; margin: auto">
          <h1 class="h3 mt-5 mb-0 font-weight-normal">Invalid link</h1>
          <p>
            The password reset link was invalid, possibly because it has already
            been used.
            <br />
            <a [routerLink]="'/password-reset'"
              >Please request a new password reset.</a
            >
          </p>
        </div>
      } @else {
        <div class="col" style="max-width: 40rem; margin: auto">
          <h1 class="h3 mt-5 mb-0 font-weight-normal">Something went wrong</h1>
          <p>
            Setting new password is currently not possible.
            <br />
            Please try again later or <a routerLink="/contact"> contact </a> our
            support team.
          </p>
        </div>
      }
    </div>
  </div>
</main>
